import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/GlobalStyles';

const MyDayContainer = styled.div`
  width: 100%;
  height: calc(100vh - 80px);
  padding: ${theme.spacing.lg};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.md};
    height: calc(100vh - 60px);
  }
`;

const ComingSoonContainer = styled.div`
  text-align: center;
  max-width: 500px;
  padding: 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #f0f1f3;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 24px;
    border-radius: 12px;
    margin: 0 16px;
  }
`;

const ComingSoonTitle = styled.h1`
  color: ${theme.colors.primary};
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 16px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 2rem;
    margin-bottom: 12px;
  }
`;

const ComingSoonSubtitle = styled.h2`
  color: #5f6368;
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 24px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 1rem;
    margin-bottom: 20px;
  }
`;

const ComingSoonDescription = styled.p`
  color: #666;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 32px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 0.9rem;
    margin-bottom: 24px;
  }
`;

const FeatureList = styled.ul`
  text-align: left;
  color: #666;
  font-size: 0.95rem;
  line-height: 1.8;
  margin: 0;
  padding-left: 20px;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 0.85rem;
    padding-left: 16px;
  }
`;

const FeatureItem = styled.li`
  margin-bottom: 8px;
  
  &::marker {
    color: ${theme.colors.primary};
  }
`;

const MyDayPage: React.FC = () => {
  return (
    <MyDayContainer>
      <ComingSoonContainer>
        <ComingSoonTitle>Coming Soon</ComingSoonTitle>
        <ComingSoonSubtitle>My Day - Daily Focus</ComingSoonSubtitle>
        <ComingSoonDescription>
          Your daily command center is being designed to help you focus on what matters most. 
          This daily view will help you manage your energy, prioritise tasks, 
          and maintain momentum throughout your day.
        </ComingSoonDescription>
        
        <FeatureList>
          <FeatureItem>Energy-based task scheduling for optimal productivity</FeatureItem>
          <FeatureItem>Morning routine and daily intention setting</FeatureItem>
          <FeatureItem>Real-time progress tracking with visual feedback</FeatureItem>
          <FeatureItem>Break reminders and focus management</FeatureItem>
          <FeatureItem>Evening reflection and tomorrow's preparation</FeatureItem>
          <FeatureItem>Mood and energy level tracking throughout the day</FeatureItem>
        </FeatureList>
      </ComingSoonContainer>
    </MyDayContainer>
  );
};

export default MyDayPage; 